import { addYears, DffOprindeligAktuelVaerdi, EntitetStatus } from "@dffedb/util";
import { Note } from "@e-forsyning/common/note";

import { KomponentBruger } from "./komponent-bruger.model";
import { KomponentDimension } from "./komponent-dimension.model";
import { KomponentType } from "./komponent-type.model";

export class Komponent {
    public bruger: KomponentBruger;
    public dimensioner: KomponentDimension[];
    public id: number;
    public komponentTypeId: number;
    public nedtagetDato: DffOprindeligAktuelVaerdi<Date>;
    public noter: Note[];
    public opsatDato: DffOprindeligAktuelVaerdi<Date>;
    public senestServiceDato: DffOprindeligAktuelVaerdi<Date>;
    public serieNr: DffOprindeligAktuelVaerdi<string>;
    public serviceDato: DffOprindeligAktuelVaerdi<Date>;
    public status: EntitetStatus;
    public tekst: DffOprindeligAktuelVaerdi<string>;
}

export function opretTomKomponent(komponentType: KomponentType): Komponent {
    const udfyldServiceDatoer = komponentType.serviceinterval > 0;
    const senestServiceDato = udfyldServiceDatoer ? new Date() : null;
    const naesteServiceDato = udfyldServiceDatoer ? addYears(new Date(), komponentType.serviceinterval) : null;

    const result: Komponent = {
        bruger: {
            initialer: "",
            navn: ""
        },
        dimensioner: [],
        id: 0,
        komponentTypeId: komponentType.id,
        nedtagetDato: { aktuel: null, oprindelig: null },
        noter: [],
        opsatDato: { aktuel: new Date(), oprindelig: new Date() },
        senestServiceDato: { aktuel: senestServiceDato, oprindelig: senestServiceDato },
        serieNr: { aktuel: "", oprindelig: "" },
        serviceDato: { aktuel: naesteServiceDato, oprindelig: naesteServiceDato },
        status: EntitetStatus.Tilfoejet,
        tekst: { aktuel: "", oprindelig: "" }
    };
    return result;
}
